import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setToastMessage, shortlist } from './../../../../actionCreators/common';
import { isEmptyObject } from './../../../../utils/helper';

export const ContactLensWishIcon = props => {
  const { productId } = props;

  const { SL_EXCEEDED_MESSAGE, SUCCESSFULLY_REMOVED, SUCCESSFULLY_ADDED } = useSelector(
    state => state.locale
  );
  const shortListData = useSelector(state => state.common.shortListData);
  const login = useSelector(state => state.common.login);
  const wishlistCount = useSelector(state => state.common.isWishlistCount);
  const dispatch = useDispatch();

  const shortListProduct = shortListData?.result?.productIds.concat(
    shortListData.result.productList.map(({ id }) => id)
  );
  const isShortlisted = shortListProduct?.indexOf(productId) > -1;
  const [message, setMessage] = useState({});
  const [isRedHeart, setIsRedHeart] = useState(false);

  const onClickWishList = event => {
    event.preventDefault();
    event.stopPropagation();

    setIsRedHeart(!isRedHeart);

    sessionStorage.setItem('hideshortlistinfo', true);

    if (!isShortlisted && wishlistCount >= 50) {
      dispatch(setToastMessage({ message: SL_EXCEEDED_MESSAGE, timeout: 2000 }));
      return;
    }

    if (isShortlisted) {
      dispatch(shortlist(null, 'delete', `/${productId}`));

      setMessage({ message: SUCCESSFULLY_REMOVED, timeout: 3000 });
    } else {
      dispatch(shortlist(productId, 'post', ''));

      setMessage({ message: SUCCESSFULLY_ADDED, timeout: 3000 });
    }

    if (window.dtm.LenskartRewamp) {
      if (isShortlisted) {
        window.dtm.LenskartRewamp.Listing.click.removeProdcutShortlist(login, productId.toString());
      } else {
        window.dtm.LenskartRewamp.Listing.click.shortlist(productId.toString());
      }
    }
  };

  useEffect(() => {
    if (productId && !isEmptyObject(message) && wishlistCount !== 50) {
      dispatch(setToastMessage(message));
    }
  }, [dispatch, message, productId, wishlistCount]);

  return (
    <img
      alt="Add To Wish List"
      src={`https://static.lenskart.com/owndays/img/contact-lens-pdp/icons/heart-${
        isRedHeart ? 'active' : 'inactive'
      }.svg`}
      onClick={productId ? onClickWishList : () => setIsRedHeart(prev => !prev)}
    />
  );
};
